export default {
  penalty: 20,
  showSolution: false,
  hideMap: true,
  legs: [
    {
      imageLocation: '/lockdown/teams/A.png',
      scale: 1,
      startLocation: [178, 432],
      finishLocation: [187, 58],
      compulsoryPoints: [
        { location: [127, 366], size: 25 },
        { location: [45, 235], size: 25 },
        { location: [104, 102], size: 28 },
      ],
      disallowedPoints: [],
      correctPath: [
        [129, 358],
        [72, 265],
        [43, 206],
        [42, 173],
        [63, 149],
        [179, 56],
      ],
    },
    {
      imageLocation: '/lockdown/teams/B.png',
      scale: 1,
      startLocation: [177, 319],
      finishLocation: [179, 138],
      compulsoryPoints: [
        { location: [99, 322], size: 22 },
        { location: [31, 262], size: 22 },
        { location: [23, 86], size: 22 },
        { location: [162, 43], size: 22 },
      ],
      disallowedPoints: [],
      correctPath: [
        [43, 314],
        [31, 192],
        [31, 66],
        [40, 17],
        [115, 10],
        [146, 25],
        [166, 58],
        [181, 75],
        [180, 135],
      ],
    },
    {
      imageLocation: '/lockdown/teams/C.png',
      scale: 0.6,
      startLocation: [110, 389],
      finishLocation: [110, 167],
      compulsoryPoints: [
        { location: [147, 372], size: 18 },
        { location: [235, 370], size: 15 },
        { location: [289, 317], size: 18 },
        { location: [275, 160], size: 18 },
        { location: [151, 101], size: 18 },
      ],
      disallowedPoints: [
        { location: [93, 317], size: 15 },
        { location: [63, 362], size: 15 },
      ],
      correctPath: [
        [146, 374],
        [197, 364],
        [258, 375],
        [319, 246],
        [319, 222],
        [297, 194],
        [243, 126],
        [193, 70],
        [183, 69],
        [111, 162],
      ],
    },
    {
      imageLocation: '/lockdown/teams/D.png',
      scale: 1,
      startLocation: [295, 543],
      finishLocation: [298, 98],
      compulsoryPoints: [
        { location: [225, 567], size: 25 },
        { location: [116, 347], size: 20 },
        { location: [29, 172], size: 20 },
        { location: [179, 126], size: 20 },
      ],
      disallowedPoints: [],
      correctPath: [
        [213, 566],
        [24, 161],
        [294, 97],
      ],
    },
    {
      imageLocation: '/lockdown/teams/E.png',
      scale: 0.6,
      startLocation: [125, 384],
      finishLocation: [124, 54],
      compulsoryPoints: [
        { location: [79, 342], size: 18 },
        { location: [106, 46], size: 18 },
        { location: [17, 80], size: 18 },
        { location: [73, 228], size: 15 },
        { location: [72, 280], size: 15 },
        { location: [59, 157], size: 16.5 },
      ],
      disallowedPoints: [
        { location: [40, 384], size: 13 },
        { location: [38, 325], size: 13 },
        { location: [27, 206], size: 13 },
        { location: [116, 190], size: 13 },
        { location: [124, 310], size: 13 },
        { location: [171, 368], size: 13 },
        { location: [49, 86], size: 10 },
        { location: [56, 98], size: 10 },
        { location: [61, 109], size: 10 },
        { location: [68, 121], size: 10 },
        { location: [61, 81], size: 10 },
        { location: [72, 71], size: 10 },
      ],
      correctPath: [
        [99, 384],
        [71, 320],
        [75, 199],
        [14, 74],
        [99, 34],
        [109, 58],
        [125, 51],
      ],
    },
    {
      imageLocation: '/lockdown/teams/F.png',
      scale: 1,
      startLocation: [271, 481],
      finishLocation: [270, 197],
      compulsoryPoints: [
        { location: [434, 364], size: 20 },
        { location: [443, 245], size: 20 },
        { location: [366, 209], size: 30 },
      ],
      disallowedPoints: [
        { location: [286, 420], size: 25 },
        { location: [348, 448], size: 30 },
        { location: [424, 557], size: 15 },
        { location: [204, 483], size: 15 },
        { location: [182, 432], size: 15 },
      ],
      correctPath: [
        [388, 540],
        [446, 318],
        [439, 223],
        [272, 199],
      ],
    },
    {
      imageLocation: '/lockdown/teams/G.png',
      scale: 1,
      startLocation: [337, 467],
      finishLocation: [339, 115],
      compulsoryPoints: [
        { location: [359, 534], size: 30 },
        { location: [603, 456], size: 30 },
        { location: [642, 367], size: 30 },
        { location: [516, 533], size: 30 },
        { location: [502, 170], size: 25 },
        { location: [420, 116], size: 25 },
      ],
      disallowedPoints: [
        { location: [247, 256], size: 25 },
        { location: [458, 262], size: 15 },
        { location: [414, 221], size: 15 },
        { location: [380, 174], size: 15 },
      ],
      correctPath: [
        [360, 532],
        [518, 537],
        [591, 466],
        [641, 353],
        [527, 195],
        [419, 120],
        [391, 107],
        [341, 116],
      ],
    },
    {
      imageLocation: '/lockdown/teams/H.png',
      scale: 1,
      startLocation: [183, 386],
      finishLocation: [183, 74],
      compulsoryPoints: [],
      disallowedPoints: [
        { location: [282, 240], size: 15 },
        { location: [285, 258], size: 15 },
        { location: [291, 274], size: 15 },
        { location: [295, 293], size: 15 },
        { location: [300, 304], size: 15 },
        { location: [324, 325], size: 30 },
        { location: [348, 238], size: 30 },
        { location: [268, 264], size: 15 },
        { location: [276, 286], size: 15 },
        { location: [277, 298], size: 15 },
        { location: [211, 270], size: 15 },
        { location: [196, 273], size: 10 },
        { location: [196, 287], size: 10 },
        { location: [200, 298], size: 10 },
        { location: [205, 312], size: 10 },
        { location: [205, 325], size: 10 },
        { location: [212, 336], size: 10 },
        { location: [307, 218], size: 10 },
        { location: [307, 243], size: 10 },
        { location: [304, 229], size: 10 },
        { location: [293, 236], size: 10 },
        { location: [49, 441], size: 30 },
        { location: [23, 78], size: 30 },
        { location: [101, 160], size: 30 },
        { location: [136, 151], size: 30 },
        { location: [172, 134], size: 30 },
        { location: [212, 122], size: 30 },
        { location: [254, 102], size: 30 },
        { location: [237, 154], size: 30 },
        { location: [196, 170], size: 30 },
        { location: [156, 181], size: 30 },
        { location: [115, 204], size: 30 },
        { location: [122, 306], size: 15 },
        { location: [136, 304], size: 15 },
        { location: [137, 327], size: 15 },
        { location: [137, 342], size: 15 },
        { location: [148, 359], size: 15 },
        { location: [149, 369], size: 15 },
      ],
      correctPath: [
        [171, 262],
        [265, 198],
        [308, 122],
        [312, 109],
        [289, 50],
        [186, 69],
      ],
    },
    {
      imageLocation: '/lockdown/teams/I.png',
      scale: 1,
      startLocation: [227, 395],
      finishLocation: [227, 67],
      compulsoryPoints: [
        { location: [367, 226], size: 20 },
        { location: [372, 158], size: 20 },
        { location: [357, 79], size: 20 },
        { location: [303, 59], size: 20 },
        { location: [328, 294], size: 30 },
        { location: [290, 387], size: 25 },
      ],
      disallowedPoints: [
        { location: [103, 206], size: 15 },
        { location: [108, 253], size: 15 },
        { location: [114, 294], size: 15 },
        { location: [119, 338], size: 15 },
        { location: [122, 389], size: 15 },
        { location: [269, 187], size: 15 },
        { location: [254, 215], size: 15 },
        { location: [268, 293], size: 15 },
        { location: [125, 439], size: 15 },
        { location: [88, 102], size: 25 },
      ],
      correctPath: [
        [290, 394],
        [358, 239],
        [379, 210],
        [352, 62],
        [332, 57],
        [227, 64],
      ],
    },
    {
      imageLocation: '/lockdown/teams/J.png',
      scale: 0.5,
      startLocation: [263, 564],
      finishLocation: [264, 57],
      compulsoryPoints: [
        { location: [315, 540], size: 18 },
        { location: [350, 494], size: 18 },
        { location: [281, 363], size: 18 },
        { location: [316, 427], size: 18 },
        { location: [245, 288], size: 18 },
        { location: [241, 96], size: 30 },
        { location: [244, 241], size: 20 },
      ],
      disallowedPoints: [
        { location: [146, 423], size: 15 },
        { location: [223, 347], size: 15 },
        { location: [291, 310], size: 15 },
        { location: [205, 280], size: 15 },
        { location: [284, 247], size: 15 },
        { location: [339, 128], size: 20 },
        { location: [133, 164], size: 20 },
      ],
      correctPath: [
        [277, 567],
        [364, 519],
        [260, 327],
        [241, 271],
        [248, 231],
        [287, 200],
        [241, 117],
        [263, 61],
      ],
    },
  ],
}
